import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import ListingCard from "@/components/ListingCard";
import { CATEGORY_ICON } from "@/data/brand";

export default function CategoryPage() {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategory(r.data.find((c) => c.slug === slug)));
    setLoading(true);
    api.get(`/listings?category=${slug}`).then((r) => setListings(r.data)).finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-testid="category-page">
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[#FFBE00] mb-2">· Categoria</div>
        <div className="flex items-center gap-4">
          {category && <i className={`fas ${CATEGORY_ICON[category.slug]} text-4xl text-[#E619A8]`}></i>}
          <h1 className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl leading-tight">{category?.name || "—"}</h1>
        </div>
        {category && (
          <div className="mt-4 flex gap-6 text-sm text-zinc-400">
            <span>Piano: <span className="text-white font-bold">{category.tier.toUpperCase()}</span></span>
            <span>Dal <span className="text-[#FFBE00] font-bold">€{category.pricing.monthly}/mese</span></span>
            <Link to="/prezzi" className="underline hover:text-[#FFBE00]">Vedi dettagli prezzi →</Link>
          </div>
        )}
      </header>

      <div className="text-sm text-zinc-500 mb-4">{loading ? "Caricamento…" : `${listings.length} annunci in questa categoria`}</div>
      {!loading && listings.length === 0 && (
        <div className="hm-card p-12 text-center text-zinc-400" data-testid="category-empty">
          <i className="fas fa-inbox text-4xl text-zinc-700 mb-3"></i>
          <div>Nessun annuncio ancora. <Link to="/registrati" className="text-[#FFBE00] hover:underline">Sii il primo!</Link></div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {listings.map((l) => <ListingCard key={l.id} listing={l} />)}
      </div>
    </div>
  );
}
